import { Typography } from '@navi/web-ui/lib/primitives';
import KeyValue from '../KeyValue';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { capitalizeFirstLetter } from '@cp/src/pages/AllAgents/AgentForm/utils/utils';
import { AnomalyType } from '../../types';
import MapIcon from '@cp/src/assets/icons/MapIcon';
import { redirectToAgentDetails } from '@cp/src/utils/commonUtils';
import { getNameDetailsWithNo } from '../../utils';
import dayjs from 'dayjs';
import { DateFormat } from '@cp/src/utils/DateHelper';

const RaisedForDetails = () => {
  const anomalyDetails = useSelector(
    (state: RootState) => state?.anomalyTracker?.anomalyDetails?.data
  );
  const externalAgencyPerformanceDashboard = useSelector(
    (state: RootState) => state?.common?.featureFlags?.externalAgencyPerformanceDashboard
  );

  const { raisedFor, anomalyDetectedOn, createdAt } = anomalyDetails || {};

  const {
    name,
    id: agentId,
    phoneNumber,
    allocations,
    agencyCode,
    agencyName,
    reportingManager,
    reportingManagerNumber
  } = raisedFor || {};

  const showMapIcon = anomalyDetectedOn === AnomalyType.AGENT && agentId;

  const handleMapRedirection = () => {
    const mapViewDate = dayjs(createdAt).format(DateFormat.ISO_DATE_FORMAT);
    redirectToAgentDetails(agentId, agencyCode, mapViewDate, externalAgencyPerformanceDashboard);
  };

  return (
    <div>
      <Typography color="var(--grayscale-2)" variant="h3" className="mb-4 mt-5">
        Raised For
      </Typography>
      <KeyValue
        title="Name"
        description={getNameDetailsWithNo(name, phoneNumber)}
        rightIcon={
          showMapIcon ? (
            <div className="cursor-pointer ml-1" onClick={handleMapRedirection}>
              <MapIcon />
            </div>
          ) : null
        }
      />
      <KeyValue
        title="Role"
        description={anomalyDetectedOn ? capitalizeFirstLetter(anomalyDetectedOn) : null}
      />
      <KeyValue title="Agency" description={agencyName} />
      <KeyValue title="Cases allocated in bucket 1-3" description={allocations} />
      <KeyValue
        title="Supervisor"
        description={getNameDetailsWithNo(reportingManager, reportingManagerNumber)}
      />
    </div>
  );
};

export default RaisedForDetails;
